module.exports = __webpack_public_path__ + "static/statusBar-ae8ee4bb8ae659a90bc540b927d2399e.gif";